<template>
    <div class="main">
        <section id="brn-attraction-single" class="diagonal">
            <BorderDecoration class="top-left" style="left: -10%" :primary="'var(--color-secondary)'" :secondary="'var(--color-gray-light)'"/>
            <div class="container">
                <div class="row">
                    <div class="col-xl-6 intro">
                        <h6 class="text-uppercase text-wide-5 text-secondary">attraction / {{ attraction.title }}</h6>
                        <ChalkDecoration>
                            <h2>{{ attraction.title }}</h2>
                        </ChalkDecoration>
                        <div class="row my-5">
                            <p v-html="attraction.description"></p>
                        </div>
                        <a :href="getPageSlugByLayout('rentals')" class="btn btn-primary px-3 mb-4">Order now</a>
                    </div>
                    <div class="col-xl-6 media">
                        <img :src="attraction.image ? attraction.image : '/assets/images/backgrounds/tour-default-1.jpg'" :alt="attraction.title">
                        <GoogleMap ref="map" @ready="mapReady"/>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import BorderDecoration from "../components/elements/BorderDecoration";
import ChalkDecoration from "../components/elements/ChalkDecoration";
import SettingsMixin from "../../mixins/SettingsMixin";
import GoogleMap from "../components/elements/GoogleMap";
import ContentMixin from "../../mixins/ContentMixin";
export default {
    name: "AttractionSingle",
    mixins: [SettingsMixin, ContentMixin],
    components: {GoogleMap, ChalkDecoration, BorderDecoration},
    props: {
        attraction: {
            type: Object,
            required: true
        }
    },
    methods: {
        mapReady() {
            this.attraction.position = {
                lat: parseFloat(this.attraction.location.split(',')[0]),
                lng: parseFloat(this.attraction.location.split(',')[1])
            };
            this.$refs.map.addMarker({
                ...this.attraction,
                logoUrl: this.attraction.image
            });
            this.$refs.map.moveCenter(this.attraction.position.lat, this.attraction.position.lng);
        }
    }
}
</script>

<style scoped>

</style>
